const shareLink = {
  url: "https://app.grouped.com",
};
export default shareLink;
